import type { CSSProperties, FC } from 'react'

import { Spark } from '@/components/kit/spark'

export type BurstPiece = {
    x: number
    y: number
    rotate: number
    size: number
    color: string
    delay: number
}

const colors = ['#ffffff', '#f4f3ee', '#a7a59c', '#5c5b56', '#3ecf7a']

/**
 * Builds a fresh set of sparkle pieces. Only call this from an event handler,
 * never during render, so server and browser output always match.
 */
export const makeBurst = (count = 28): Array<BurstPiece> => Array.from({ length: count }, (_, index) => {
    const angle = (index / count) * Math.PI * 2 + Math.random() * 0.5
    const distance = 90 + Math.random() * 170

    return {
        x: Math.cos(angle) * distance,
        y: Math.sin(angle) * distance - 40,
        rotate: (Math.random() - 0.5) * 540,
        size: 8 + Math.random() * 16,
        color: colors[index % colors.length],
        delay: Math.random() * 120
    }
})

export const Burst: FC<{ pieces: Array<BurstPiece> }> = ({ pieces }) => {
    return (
        <span
            aria-hidden='true'
            className='pointer-events-none absolute left-1/2 top-1/2 z-20 size-0'
        >
            {pieces.map((piece, index) => (
                <span
                    key={index}
                    className='burst-piece'
                    style={{
                        '--x': `${piece.x.toFixed(1)}px`,
                        '--y': `${piece.y.toFixed(1)}px`,
                        '--r': `${piece.rotate.toFixed(0)}deg`,
                        width: piece.size,
                        height: piece.size,
                        color: piece.color,
                        animationDelay: `${piece.delay.toFixed(0)}ms`
                    } as CSSProperties}
                >
                    <Spark className='size-full' />
                </span>
            ))}
        </span>
    )
}
